import { createSlice } from "@reduxjs/toolkit";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../utils/LocalStorage";
import { SDK } from "../../services/ChatIndex";
import { getCookies, removeCookies, setCookies } from "../../utils/Cookies";

export interface ILoginState {
  isLoading: boolean;
  error: string;
  success: string;
  userDetails: any;
  userDetailsErrors: any;
  email: string;
  otp: any;
  emailError: string;
  isLoginOtpSent: boolean;
  isLoginOtpVerified: boolean;
  isResentLoginOtpSent: boolean;
  isRegisterOtpSent: boolean;
  isRegisterOtpVerified: boolean;
  isRegisterOtpResent: boolean;
  isProfileCreated: boolean;
  isPhoneNumberOtpVerified: boolean;
  isPhoneNumberOtpResent: boolean;
  allSkills: Array<any>;
  isSkillAdded: boolean;
  createdSkillsData: any;
  allCategories: Array<any>;
  isProfileAdded: boolean;
  isProfileNameAvailable: string;
  allRoles: any;
  loginOtpDetails: any;
  errorMessage: string;
  isSkillFetched: boolean;
  isLogoutSuccessfull: boolean;
  isOAuthSuccessfull: boolean;
  oAuthDetails: any;
  userCreatedDetails: any;
  loginDetails: any;
  createAddUserSkills: any;
  draftUserData: any;
  blockStatus: string;
}

const initialState: ILoginState = {
  isLoading: false,
  error: "",
  success: "",
  userDetails: {
    fullName: "",
    gender: "",
    phoneNumber: {
      number: "",
      countryCode: "+91",
    },
    dateOfBirth: new Date('2006-01-01'),
    otp: "",
    userName: "",
    roles: [],
    country: "India",
    state: "",
    city: "",
    countryName: "In",
    stateName: "",
  },
  userDetailsErrors: {
    fullName: "",
    gender: "",
    phoneNumber: "",
    dateOfBirth: "",
    userName: "",
    roles: "",
    state: "",
    city: ""
  },
  email: "",
  emailError: "",
  otp: "",
  isLoginOtpSent: false,
  isLoginOtpVerified: false,
  isResentLoginOtpSent: false,
  isRegisterOtpSent: false,
  isRegisterOtpVerified: false,
  isRegisterOtpResent: false,
  isProfileCreated: false,
  isPhoneNumberOtpVerified: false,
  isPhoneNumberOtpResent: false,
  allSkills: [],
  isSkillAdded: false,
  createdSkillsData: [],
  allCategories: [],
  isProfileAdded: false,
  isProfileNameAvailable: "",
  allRoles: [],
  loginOtpDetails: {},
  errorMessage: "",
  isSkillFetched: false,
  isLogoutSuccessfull: false,
  isOAuthSuccessfull: false,
  oAuthDetails: null,
  userCreatedDetails: {},
  loginDetails: {},
  createAddUserSkills: {},
  draftUserData: {
    email: '',
    otp: '',
    fullName: '',
    userName: '',
    dob: '',
    skillIds: [],
    categories: [],
    phoneNumber: '',
    countryCode: '+91',
    city: ''
  },
  blockStatus: ""
};

const reloadWindow = () => {
  const reloadTimer = setTimeout(() => {
    window.location.reload();
  }, 3000);

  return () => clearTimeout(reloadTimer);
};

export const loginRedux: any = createSlice({
  name: "loginRedux",
  initialState,
  reducers: {
    resetState: (state: any, action: any) => {
      return initialState;
    },
    setLoginState: (state: any, action: any) => {
      const newState = {
        ...state,
      };
      newState[action.payload.key] = action.payload.value;
      return newState;
    },
    registerOtpRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isRegisterOtpSent: false,
      };
      return newState;
    },
    registerOtpSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isRegisterOtpSent: true,
        emailError: "",
      };
      return newState;
    },
    registerOtpFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isRegisterOtpSent: false,
        errorMessage: action?.payload,
        emailError: action?.payload.message,
      };
      return newState;
    },
    registerOtpVerifyRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isRegisterOtpVerified: false,
      };
      return newState;
    },
    registerOtpVerifySuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isRegisterOtpVerified: true,
      };
      return newState;
    },
    registerOtpVerifyFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isRegisterOtpVerified: false,
        errorMessage: action?.payload,
      };
      return newState;
    },
    registerResendOtpRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isRegisterOtpResent: false,
      };
      //   newState[action.payload.key] = action.payload.value;
      return newState;
    },
    registerResendOtpSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isRegisterOtpResent: true,
      };
      return newState;
    },
    registerResendOtpFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isRegisterOtpResent: false,
        errorMessage: action?.payload,
      };
      return newState;
    },
    loginOtpRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isLoginOtpSent: false,
      };
      //   newState[action.payload.key] = action.payload.value;
      return newState;
    },
    loginOtpSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isLoginOtpSent: true,
        loginOtpDetails: action?.payload,
        emailError: "",
      };
      return newState;
    },
    loginOtpFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isLoginOtpSent: false,
        errorMessage: action?.payload,
        emailError: action?.payload.message,
        loginOtpDetails: action?.payload,
      };
      return newState;
    },
    loginOtpVerifyRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isLoginOtpVerified: false,
      };
      return newState;
    },
    loginOtpVerifySuccess: (state: any, action: any) => {
      setLocalStorageItem("token", action?.payload?.data?.accessToken);
      setCookies("userDetails", JSON.stringify(action?.payload?.data));

      const newState = {
        ...state,
        isLoading: false,
        isLoginOtpVerified: true,
      };
      return newState;
    },
    loginOtpVerifyFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isLoginOtpVerified: false,
        errorMessage: action?.payload,
      };
      return newState;
    },
    resendLoginOtpRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isResentLoginOtpSent: false,
      };
      return newState;
    },
    resendLoginOtpSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isResentLoginOtpSent: true,
      };
      return newState;
    },
    resendLoginOtpFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isResentLoginOtpSent: false,
        errorMessage: action?.payload,
      };
      return newState;
    },
    createProfileRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isProfileCreated: false,
      };
      return newState;
    },
    createProfileSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProfileCreated: true,
      };
      return newState;
    },
    createProfileFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProfileCreated: false,
        errorMessage: action?.payload,
      };
      return newState;
    },
    createProfilePhoneNumberOtpVerifyRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isPhoneNumberOtpVerified: false,
      };
      return newState;
    },
    createProfilePhoneNumberOtpVerifySuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPhoneNumberOtpVerified: true,
      };
      return newState;
    },
    createProfilePhoneNumberOtpVerifyFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPhoneNumberOtpVerified: false,
        errorMessage: action?.payload,
      };
      return newState;
    },
    createProfileResendPhoneNumberOtpRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isPhoneNumberOtpResent: false,
      };
      return newState;
    },
    createProfileResendPhoneNumberOtpSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPhoneNumberOtpResent: true,
      };
      return newState;
    },
    createProfileResendPhoneNumberOtpFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPhoneNumberOtpResent: false,
        errorMessage: action?.payload,
      };
      return newState;
    },
    checkUserNameAvaibilityRequest: (state: any, action: any) => {
      const newState = {
        ...state,
      };
      return newState;
    },
    checkUserNameAvaibilitySuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProfileNameAvailable: action.payload?.message,
      };
      return newState;
    },
    checkUserNameAvaibilityFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },
    createUserNameRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isProfileAdded: false,
      };
      return newState;
    },
    createUserNameSuccess: (state: any, action: any) => {
      // setLocalStorageItem("token", action?.payload?.data?.accessToken);
      // setLocalStorageItem("userDetails", JSON.stringify(action?.payload?.data));
      const newState = {
        ...state,
        isLoading: false,
        userCreatedDetails: action?.payload?.data,
        isProfileAdded: true,
      };
      return newState;
    },
    createUserNameFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProfileAdded: false,
      };
      return newState;
    },

    // create user - add skills
    addUserSkillsRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        createAddUserSkills: {},
      };
      return newState;
    },
    addUserSkillsSuccess: (state: any, action: any) => {
      window.location.reload();
      setLocalStorageItem("token", action?.payload?.data?.accessToken);
      setCookies("userDetails", JSON.stringify(action?.payload?.data));
      const newState = {
        ...state,
        isLoading: false,
        createAddUserSkills: action?.payload?.state,
      };
      return newState;
    },
    addUserSkillsFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        createAddUserSkills: {},
      };
      return newState;
    },

    // skills
    getAllSkillsRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isSkillFetched: false,
      };
      return newState;
    },
    getAllSkillsSuccess: (state: any, action: any) => {
      const formatSkills = action.payload?.data?.map(
        (skill: any, skillIndex: number) => {
          return {
            ...skill,
            name: skill?.skill,
          };
        }
      );
      const newState = {
        ...state,
        isLoading: false,
        allSkills: formatSkills,
        isSkillFetched: true,
      };
      return newState;
    },
    getAllSkillsFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isSkillFetched: false,
      };
      return newState;
    },
    createSkillRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isSkillAdded: false,
        createdSkillsData: [],
      };
      return newState;
    },
    createSkillSuccess: (state: any, action: any) => {
      const response = action.payload.data;
      const newState = {
        ...state,
        isLoading: false,
        isSkillAdded: true,
        createdSkillsData: response,
      };
      return newState;
    },
    createSkillFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isSkillAdded: false,
        createdSkillsData: []
      };
      return newState;
    },
    getAllCategoriesRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    getAllCategoriesSuccess: (state: any, action: any) => {
      const formatCategories = action?.payload?.data?.map((category: any) => {
        return {
          ...category,
          isSelected: false,
        };
      });
      const newState = {
        ...state,
        isLoading: false,
        allCategories: formatCategories,
      };
      return newState;
    },
    getAllCategoriesFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },
    getAllRolesRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    getAllRolesSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        allRoles: action?.payload?.data,
      };
      return newState;
    },
    getAllRolesFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },
    refreshAuthTokenRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    refreshAuthTokenSuccess: (state: any, action: any) => {
      setLocalStorageItem("token", action?.payload?.data?.accessToken);
      // setLocalStorageItem("userDetails", JSON.stringify(action?.payload?.data));
      setCookies("userDetails", JSON.stringify(action?.payload?.data));
      reloadWindow();
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },
    refreshAuthTokenFailure: (state: any, action: any) => {
      localStorage.clear();
      removeCookies("userDetails", new Date());
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },
    logOutRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLogoutSuccessfull: false,
      };
      return newState;
    },
    logOutDifferentUserRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLogoutSuccessfull: false,
      };
      return newState;
    },
    logOutSuccess: (state: any, action: any) => {
      const logout = async () => {
        await SDK.logout();
      };
      logout();
      const newState = {
        ...state,
        isLogoutSuccessfull: true,
        email: ""
      };
      return newState;
    },
    logOutFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLogoutSuccessfull: false,
        isLoading: false,
      };
      return newState;
    },
    registerWithGoogleRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isOAuthSuccessfull: false,
        isLoading: true,
      };
      return newState;
    },
    registerWithGoogleSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isOAuthSuccessfull: true,
        oAuthDetails: action?.payload?.data,
        isLoading: false,
      };
      return newState;
    },
    registerWithGoogleFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isOAuthSuccessfull: false,
        isLoading: false,
      };
      return newState;
    },
    //facebook login
    registerWithFacebookRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isOAuthSuccessfull: false,
        isLoading: true,
      };
      return newState;
    },
    registerWithFacebookSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isOAuthSuccessfull: true,
        oAuthDetails: action?.payload?.data,
        isLoading: false,
      };
      return newState;
    },
    registerWithFacebookFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isOAuthSuccessfull: false,
        isLoading: false,
      };
      return newState;
    },
    disconnectAndDestroySessionIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    disconnectAndDestroySessionIdSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },
    disconnectAndDestroySessionIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },
    generateSessionIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    generateSessionIdSuccess: (state: any, action: any) => {
      const cachedUserDetails: any = getCookies("userDetails");
      const loggedInUserDetails: any = JSON.parse(cachedUserDetails);
      const newCacheData: any = {
        ...loggedInUserDetails,
        sessionId: action?.payload?.data?.sessionId,
      };
      // console.log("newCacheData", newCacheData);
      // setLocalStorageItem("userDetails", JSON.stringify(newCacheData));
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },
    generateSessionIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    // to get login Activity details
    getAllLoginRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    getAllLoginSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        loginDetails: action?.payload
      };
      return newState;
    },
    getAllLoginFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    // to update user email
    updateEmailRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    updateEmailSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        loginDetails: action?.payload
      };
      return newState;
    },
    updateEmailFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    // to update user phone number
    updatePhoneRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    updatePhoneSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        loginDetails: action?.payload
      };
      return newState;
    },
    updatePhoneFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    // to update FCM token
    updateFCMTokenRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    updateFCMTokenSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },
    updateFCMTokenFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    // Delete User Account 
    deleteAccountRequest: (state, action) => {
      state.isLoading = true;
    },
    deleteAccountSuccess: (state, action) => {
      state.isLoading = false;
      state.success = "Deleted Successfully";
    },
    deleteAccountFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Block User Account 
    blockUserRequest: (state, action) => {
      state.isLoading = true;
    },
    blockUserSuccess: (state, action) => {
      console.log(action.payload)
      state.isLoading = false;
      state.success = "Blocked Successfully";
      state.blockStatus = action?.payload?.message
    },
    blockUserFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    draftUserData: (state, action) => {
      state.draftUserData = action.payload
    }
  },
});

export const {
  setLoginState,
  resetState,

  loginOtpRequest,
  loginOtpSuccess,
  loginOtpFailure,

  loginOtpVerifyRequest,
  loginOtpVerifySuccess,
  loginOtpVerifyFailure,

  resendLoginOtpRequest,
  resendLoginOtpSuccess,
  resendLoginOtpFailure,

  registerOtpRequest,
  registerOtpSuccess,
  registerOtpFailure,

  registerOtpVerifyRequest,
  registerOtpVerifySuccess,
  registerOtpVerifyFailure,

  registerResendOtpRequest,
  registerResendOtpSuccess,
  registerResendOtpFailure,

  createProfileRequest,
  createProfileSuccess,
  createProfileFailure,

  createProfilePhoneNumberOtpVerifyRequest,
  createProfilePhoneNumberOtpVerifySuccess,
  createProfilePhoneNumberOtpVerifyFailure,

  createProfileResendPhoneNumberOtpRequest,
  createProfileResendPhoneNumberOtpSuccess,
  createProfileResendPhoneNumberOtpFailure,

  checkUserNameAvaibilityRequest,
  checkUserNameAvaibilitySuccess,
  checkUserNameAvaibilityFailure,

  createUserProfileRequest,
  createUserProfileSuccess,
  createUserProfileFailure,

  addUserSkillsRequest,
  addUserSkillsSuccess,
  addUserSkillsFailure,

  getAllSkillsRequest,
  getAllSkillsSuccess,
  getAllSkillsFailure,

  createSkillRequest,
  createSkillSuccess,
  createSkillFailure,

  createUserNameRequest,
  createUserNameSuccess,
  createUserNameFailure,

  getAllCategoriesRequest,
  getAllCategoriesSuccess,
  getAllCategoriesFailure,

  getAllRolesRequest,
  getAllRolesSuccess,
  getAllRolesFailure,

  refreshAuthTokenRequest,
  refreshAuthTokenSuccess,
  refreshAuthTokenFailure,

  logOutRequest,
  logOutSuccess,
  logOutFailure,

  getAllLoginRequest,
  getAllLoginSuccess,
  getAllLoginFailure,

  updateEmailRequest,
  updateEmailSuccess,
  updateEmailFailure,

  updatePhoneRequest,
  updatePhoneSuccess,
  updatePhoneFailure,

  registerWithGoogleRequest,
  registerWithGoogleSuccess,
  registerWithGoogleFailure,

  registerWithFacebookRequest,
  registerWithFacebookSuccess,
  registerWithFacebookFailure,

  disconnectAndDestroySessionIdRequest,
  disconnectAndDestroySessionIdSuccess,
  disconnectAndDestroySessionIdFailure,

  generateSessionIdRequest,
  generateSessionIdSuccess,
  generateSessionIdFailure,

  updateFCMTokenRequest,
  updateFCMTokenSuccess,
  updateFCMTokenFailure,

  deleteAccountRequest,
  deleteAccountSuccess,
  deleteAccountFailure,

  blockUserRequest,
  blockUserSuccess,
  blockUserFailure,

  draftUserData

} = loginRedux.actions;

export default loginRedux.reducer;
